import { useOrganization } from '../contexts/OrganizationContext'

export function useSubscriptionFeatures() {
  const { organization, loading } = useOrganization()
  
  const subscription = organization?.subscription
  const isTrainerMode = subscription?.tier_type === 'trainer'
  const isTrainerPlan = subscription?.plan_code === 'trainer'
  
  // Debug logging
  console.log('🔍 useSubscriptionFeatures:', {
    loading,
    organizationName: organization?.name,
    tierType: subscription?.tier_type,
    planCode: subscription?.plan_code,
    isTrainerMode
  })
  
  const hasFeature = (feature: string): boolean => {
    if (!subscription) return false
    
    // Enterprise has all features
    if (subscription.features.all_features === true) return true
    
    // Check specific feature
    return subscription.features[feature] === true
  }
  
  const isWithinLimit = (metric: 'facilities' | 'members' | 'clients' | 'staff', current: number): boolean => {
    if (!subscription?.limits) return true
    
    const limit = subscription.limits[`max_${metric}` as keyof typeof subscription.limits]
    
    // -1 means unlimited
    if (limit === -1 || limit === undefined) return true
    
    return current <= limit
  }
  
  const getLimit = (metric: 'facilities' | 'members' | 'clients' | 'staff'): number | null => {
    if (!subscription?.limits) return null
    
    const limit = subscription.limits[`max_${metric}` as keyof typeof subscription.limits]
    
    // -1 means unlimited
    if (limit === -1) return null
    
    return limit || null
  }
  
  // Get appropriate terminology based on subscription
  const getTerminology = () => {
    if (isTrainerMode) {
      return {
        members: 'clients',
        member: 'client',
        Members: 'Clients',
        Member: 'Client',
        facilities: 'venues',
        facility: 'venue',
        Facilities: 'Venues',
        Facility: 'Venue'
      }
    }
    
    return {
      members: 'members',
      member: 'member',
      Members: 'Members',
      Member: 'Member',
      facilities: 'facilities',
      facility: 'facility',
      Facilities: 'Facilities',
      Facility: 'Facility'
    }
  }
  
  return {
    subscription,
    isTrainerMode,
    isTrainerPlan,
    hasFeature,
    isWithinLimit,
    getLimit,
    getTerminology,
    subscriptionStatus: subscription?.status || null,
    planCode: subscription?.plan_code || null,
    isLoading: loading
  }
}